/**
 * Единственный css Froala на читательском пути: 108 правил `.fr-view`, то
 * есть оформление тела статьи. Остальные 233 КБ стилей редактора живут в
 * editorChunk.js.
 *
 * Вынесен из registerFroala.js в отдельный модуль, а не require прямо там,
 * из-за алиаса `froala-editor` в tests-js/vitest.config.js: Vite матчит
 * строковый ключ алиаса по префиксу (`importee === find ||
 * importee.startsWith(find + '/')`), поэтому
 * `froala-editor/css/froala_style.min.css` резолвился бы в несуществующий
 * `.../stubs/froala-editor.js/css/froala_style.min.css`, и registerFroala.spec.js
 * падал бы на самом импорте модуля — раньше, чем до какой-либо проверки
 * дойдёт дело. Отдельный модуль с единственным require внутри спека
 * подменяет через vi.mock по относительному пути — он резолвится всегда,
 * в обход алиаса.
 */
require('froala-editor/css/froala_style.min.css');
